import { useEffect } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import useModal from "../../hooks/useModal";
import useCookies from "../../hooks/useCookies";
import ModalFixed from '../../components/modal-fixed';
import { dateTimeFormat } from "../../common/constants/Formatos";
import { addYearsFormat, formatDate, getCurrentDate, isValidDate } from "../../common/utilities/dateTime";

/** App */
function CookiesConsent() {
  const { t } = useTranslation();
  const { isShowing, open, close } = useModal();
  const { getCookieValue, setCookieValue } = useCookies();
  const cookieConsentName = "cookieConsent";

  useEffect(() => {
    const cookieConsent = getCookieValue(cookieConsentName);
    if (cookieConsent) {
      const cookieDate = formatDate(cookieConsent, dateTimeFormat);
      if (!isValidDate(cookieDate, dateTimeFormat) || getCurrentDate(dateTimeFormat) > cookieDate) {
        open();
      }
    }
    else {
      open();
    }
    // eslint-disable-next-line
  }, [])

  const accept = () => {
    setCookieValue(cookieConsentName, addYearsFormat(getCurrentDate(dateTimeFormat), 1, dateTimeFormat).toString());
  }

  return (
    <ModalFixed
      title={t("sistema.cookies.titulos.principal")}
      description={t("sistema.cookies.titulos.descripcion")}
      open={isShowing}
      onAccept={accept}
      onClose={close}
      hideCancelButton
    />
  );
}

export default CookiesConsent;
